import { useMutation } from '@tanstack/react-query';

import { PersonalExpensesApi } from '../personalExpenses.api';

export const useGetPersonalExpensesCalculationsOnCategory = () => {
  return useMutation({
    mutationFn: PersonalExpensesApi.getPersonalExpensesCalculationsByCategory,
  });
};
